import { FlatGroup } from '../../models/Template';

export interface ICentralActions {
    leftAction ?: () => any;
    leftDelete ?: boolean;
    leftSelected ?: () => any;
    ignoreAction ?: () => any;
    ignoreSelected ?: () => any;
    rightAction ?: () => any;
    rightDelete ?: boolean;
    rightSelected ?: () => any;
    isTreated ?: () => any;
    usageGuid ?: string;
    changeGuid ?: string;
}

export class GroupChangeBase {
    changes: any[];
    groups: FlatGroup[];
    templates: FlatGroup[];
    master: boolean;
    share: {
        diff?: any;
        selectedDiff?: any;
        central: ICentralActions[];
        openScript?: any;
        usages?: any;
    };

    isTreated(guid): boolean {
        return this.share.selectedDiff.fromTemplate[guid] ||
            this.share.selectedDiff.fromGroup[guid] ||
            this.share.selectedDiff.ignores[guid];
    }
}